// /* eslint-disable */
// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend
// } from "chart.js";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend
// );

// const SimpleBarChart = ({ labels, dataValues }) => {
//   const data = {
//     labels,
//     datasets: dataValues
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top",
//         labels: {
//           usePointStyle: true,
//           pointStyle: "circle",
//           boxWidth: 12,
//           boxHeight: 12,
//           padding: 14,
//           font: { size: 12 },
//         },
//       },
//       datalabels: {
//         color: "#ffffff",
//         anchor: "center",
//         align: "center",
//         font: {
//           weight: "bold",
//           size: 12,
//         },
//         formatter: (value) => value,
//       },
//     }
//   };

//   return <Bar data={data} options={options} />;
// };

// export default SimpleBarChart;

// #####################################################################
/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const SimpleBarChart = ({ labels, dataValues, showTable=true, height=250 }) => {
  const data = {
    labels,
    datasets: dataValues
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 12,
          boxHeight: 12,
          padding: 14,
          font: { size: 12 },
        },
      },
      datalabels: {
        color: "#ffffff",
        anchor: "center",
        align: "center",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value) => (value > 0 ? value : ""),
      },
    }
  };

  /* ---- Table styles (reused) ---- */
  const thStyle = {
    border: "1px solid #d2d2d2ff",
    padding: "4px",
    textAlign: "center",
    width: "100px",
    fontWeight: "bold",
    color: "#272323ff",
    background: "#f5f5f5",
  };

  const tdLabelStyle = {
    border: "1px solid #ddd",
    padding: "4px",
    textAlign: "center",
    width: "120px",
  };

  const tdValueStyle = {
    border: "1px solid #ddd",
    padding: "4px",
    textAlign: "center",
    width: "120px",
  };

  return (
    <div style={{ width: "100%", background: "#fff", padding: "16px" }}>
      {/* Chart */}
      <div style={{ height: `${height}px` }}>
      <Bar data={data} options={options} />
      </div>

      {/* Table */}
      {showTable && (
      <div style={{ marginTop: "16px", overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "11px",
          }}
        >
          <thead>
            <tr>
              <th style={thStyle}></th>
              {labels.map((label) => (
                <th key={label} style={thStyle}>{label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {dataValues.map((ds) => (
              <tr key={ds.label}>
                <td style={tdLabelStyle}><b>{ds.label}</b></td>
                {ds.data.map((val, idx) => (
                  <td key={idx} style={tdValueStyle}>{val}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>)}
    </div>
  );
};

export default SimpleBarChart;
